import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export const FIELD_DEFAULTS = {
  zip: true, incident_age_bucket: true, physically_injured: true, medical_treatment: true, at_fault: true,
  currently_represented: true, at_fault_party_insured: true,
  accident_description: false, police_report_number: false, accident_photos: false,
};

// req(field) -> required on this page; explicit(field) -> an admin rule (not the built-in default) decided it.
export function useFieldRules({ style, page, buyer }) {
  const [state, setState] = useState({ rules: FIELD_DEFAULTS, explicit: [] });
  useEffect(() => {
    let alive = true;
    api.get("/public/field-rules", { params: { style, page: page || undefined, b: buyer || undefined } })
      .then((r) => {
        if (alive) setState({ rules: { ...FIELD_DEFAULTS, ...(r.data?.rules || {}) }, explicit: r.data?.explicit || [] });
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [style, page, buyer]);
  const req = useCallback((k) => Boolean(state.rules[k]), [state]);
  const explicit = useCallback((k) => state.explicit.includes(k), [state]);
  return { req, explicit };
}

export const fieldRulePage = (vertical) => vertical?.funnelSlug || vertical?.customSlug || vertical?.slug || null;

export const zipOk = (zip, required, isValidZip) => (zip.trim() ? isValidZip(zip) : !required);
